export default __webpack_public_path__ + "static/media/icon-dashboard-1.934355eb.svg";